package com.evoapps.evoshift.domain.repository

import com.evoapps.evoshift.domain.model.Absence
import com.evoapps.evoshift.domain.model.Shift
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

interface AbsenceRepository {
    suspend fun createAbsence(absence: Absence): Result<String>
    suspend fun getAbsencesForRoster(
        workplaceId: String,
        start: String,
        end: String
    ): Result<List<Absence>>

    // Conflict Resolution
    suspend fun getOverlappingShifts(
        userId: String,
        start: String,
        end: String
    ): Result<List<Shift>>

    suspend fun getAbsencesForUser(userId: String): Result<List<Absence>>
    suspend fun getAbsencesForWorkplace(workplaceId: String): Result<List<Absence>>

    /**
     * SH-164: the workplace's absences, again after every change (the pending-request badges).
     * By default read once; a failed read is an empty list.
     */
    fun observeAbsencesForWorkplace(workplaceId: String): Flow<List<Absence>> =
        flow { emit(getAbsencesForWorkplace(workplaceId).getOrDefault(emptyList())) }

    /**
     * SH-224: [userId]'s absences at [workplaceId] that touch [from]..[to] ("YYYY-MM-DD", both
     * included), for the timeline: one query (the person, the workplace, ending on or after
     * [from]). By default the person's absences, filtered.
     */
    suspend fun getAbsencesOfUserBetween(userId: String, workplaceId: String, from: String, to: String): Result<List<Absence>> =
        getAbsencesForUser(userId).map { list ->
            list.filter { it.workplaceId == workplaceId && it.endDate >= from && it.startDate <= to }
        }

    suspend fun updateAbsence(absence: Absence): Result<Unit>
    suspend fun deleteAbsence(absenceId: String): Result<Unit>
}